import React, { forwardRef, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Typography from '../../../components/overrides/Typography';
import DownArrow from '../../../assets/icons/dropdown.svg';
import { focusVisible } from '../../../utils/ada/contrastStyles';
import { trackClickWithDescription } from '../../../utils/useOneTag';

const useStyles = makeStyles((theme) => ({
  accordion: {
    ...focusVisible(),
    borderBottom: `1px solid ${theme.palette.secondary[60]}`,
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: 'none',
    '&:last-child': {
      marginBottom: theme.spacing(1),
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  accordionSummary: {
    padding: 0,
    minHeight: theme.spacing(7),
    '&, & *': {
      cursor: ({ keepOpen }) => (keepOpen ? 'default !important' : undefined),
    },
    '& .MuiIconButton-edgeEnd': {
      display: ({ keepOpen }) => (keepOpen ? 'none' : undefined),
    },
  },
  accordionDetails: {
    padding: theme.spacing(1, 0, 2),
  },
  content: {
    margin: theme.spacing(1.5, 0),
  },
  defaultCursor: {
    cursor: 'default',
  },
}));

const FilterSection = forwardRef(function FilterSection(
  { id, list = [], title, keepOpen, defaultExpanded, children },
  ref
) {
  const classes = useStyles({ keepOpen });
  const [isExpanded, setisExpanded] = useState(keepOpen);
  useEffect(() => {
    if (ref?.current) {
      ref.current.focus();
    }
  }, [ref]);

  if (!list?.length) return null;

  const handleChange = (event, expanded) => {
    setisExpanded(expanded);
    if (expanded) {
      trackClickWithDescription(
        'search-revamp-filter-accordion',
        'Button',
        'expand ' + id
      );
    } else {
      trackClickWithDescription(
        'search-revamp-filter-accordion',
        'Button',
        'collapse ' + id
      );
    }
  };

  return (
    <Accordion
      expanded={keepOpen}
      defaultExpanded={defaultExpanded}
      onChange={handleChange}
      classes={{
        root: classes.accordion,
      }}
      role="region">
      <AccordionSummary
        id={id}
        expandIcon={
          <img src={DownArrow} alt="expand" className={classes.image} />
        }
        classes={{
          root: classes.accordionSummary,
          content: classes.content,
        }}
        aria-expanded={isExpanded}
        role={keepOpen ? 'heading' : 'button'}
        aria-disabled={keepOpen && undefined}
        aria-level={keepOpen && 1}
        tabIndex={keepOpen && -1}
        aria-controls={id}
        aria-labelledby={id}
        ref={ref}>
        <Typography variant="medium1Semibold">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
});

export default FilterSection;
